import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector, useAppDispatch } from '../hooks';
import { DeviceButton2 } from '../components/DeviceButton';
import * as LWIcon from '../components/LWIcon';
import { selectEntityState } from '../reducers/entityStatesSlice';
import { actionShades } from '../actions/ActionShades';
export const EntityHasta = props => {
    const entityState = useAppSelector(selectEntityState(props.entity.id));
    const dispatch = useAppDispatch();
    if (props.entity.title !== 'shades?' || props.action.title !== 'shades') {
        return null;
    }
    const actionType = props.action.type;
    if (actionType.name != 'enum') {
        return null;
    }
    const state = (entityState === null || entityState === void 0 ? void 0 : entityState.value.type) == 'enum' ? entityState === null || entityState === void 0 ? void 0 : entityState.value.value : undefined;
    let s1, s2, s3;
    if (state == 'up') {
        s1 = 'off';
        s2 = undefined;
        s3 = undefined;
    }
    else if (state == 'stop' || state == undefined) {
        s1 = undefined;
        s2 = 'off';
        s3 = undefined;
    }
    else if (state == 'down') {
        s1 = undefined;
        s2 = undefined;
        s3 = 'on';
    }
    else {
        s1 = undefined;
        s2 = undefined;
        s3 = undefined;
    }
    // up: <span style={{'font-weight': 'bold'}}>{"\u2B06"}</span>
    // down: <span style={{'font-weight': 'bold'}}>{"\u2B07"}</span>
    return (_jsxs("div", { className: "transmitter-buttons lw-button-group", children: [_jsx(DeviceButton2, { state: s1, onClick: () => dispatch(actionShades(props.action.id, 'up')), children: _jsx(LWIcon.ArrowUp, {}) }), _jsx(DeviceButton2, { state: s2, onClick: () => dispatch(actionShades(props.action.id, 'stop')), children: _jsx(LWIcon.Stop, {}) }), _jsx(DeviceButton2, { state: s3, onClick: () => dispatch(actionShades(props.action.id, 'down')), children: _jsx(LWIcon.ArrowDown, {}) })] }));
};
